import React from 'react';

import { Bar} from 'react-chartjs-2';
import {FormattedMessage} from 'react-intl';

const options = {
  responsive: true,
  tooltips: {
        mode: 'nearest'
  },
  legend: {
       display: false,
   },
  animation: false,
  scales: {
    barThickness: 1,
    yAxes: [{
      stacked: true,
      ticks: {
        callback: function(value) {
          return value + " m"
        }
      }
   }],
    xAxes: [{
      stacked: true,
    }]
  }
}

class MscsOpChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {

  }

  render() {
    return (
    <div className="mscsChart">
    <FormattedMessage id="mscs.opchart" defaultMessage="Operator Walking Distance"/>
    <div className="container">
        <Bar
            data={{
                  labels: this.props.labels,
                  datasets: [
                             {barThickness: 30, label: 'DISTANCE', data: this.props.datasets, backgroundColor: '#62847c'}
                            ]
                  }}
            options={options}
          />
      </div>
    </div>
    )
  }
}

export default MscsOpChart;
